// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".avatar-row[data-v-20796ae0]{align-items:center;display:flex;flex-flow:row nowrap;justify-content:flex-start}.avatar-image[data-v-20796ae0]{flex:0 0 32px;margin-right:8px}.avatar-image>img[data-v-20796ae0]{border-radius:4px}.avatar-image.avatar-person>img[data-v-20796ae0]{border-radius:50%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
